
import React from 'react';
import { Modal2 } from "../modal";
import {HighlightRects, TextLoading} from "../../funcs/utils";
import {OptionMenu} from "../../../lib/prm/option-menu";
import {Text} from "../../../lib/prm/text";
import {adminCreateUser} from "../SA_UserPortfolios/actions";
import {ACCOUNT_NUMBER} from "../SA_UserPortfolios/prm";

const render_pair = (component, label, prm, label_style={}) => {
  const container_style = {
    marginTop: "0.5rem",
    width: "100%",
    display: "flex",
  }
  let prm_div;
  if (prm instanceof OptionMenu) {
    prm_div = prm.renderMenu(component, { width: "100%"});
  } else if (prm instanceof Text) {
    prm_div = prm.renderInput(component, { width: "100%" });
  }
  return (
    <div style={container_style} key={prm.name.id}>
      <div style={{flex: "0.5"}}>
        <span style={label_style}>{label}</span>
      </div>
      <div style={{flex: "1"}}>
        { prm_div }
      </div>
    </div>
  )
}

const on_create = (component, prms) => () => {
  const { FIRST_NAME, LAST_NAME, EMAIL, ENVELOPE_ID,
    ELECTRONIC_SIGNING_TYPE, ACCOUNT_NUMBER } = prms;
  const prm_list = [ FIRST_NAME, LAST_NAME, EMAIL ];
  if (ELECTRONIC_SIGNING_TYPE.getValue(component.state).id === "signed") {
    prm_list.push(ENVELOPE_ID);
  }
  const highlight_rects = [];
  prm_list.forEach(prm => {
    prm.isFilledElseHighlight(component.state, highlight_rects);
  })

  if (highlight_rects.length > 0) {
    component.setState( { highlight_rects });
    return;
  }

  component.setState({creating_user: true});
  const account_number = ACCOUNT_NUMBER.getValue(component.state).trim() || null;
  const delivery_type = ELECTRONIC_SIGNING_TYPE.getValue(component.state).id;
  adminCreateUser(
    component.props.token,
    FIRST_NAME.getValue(component.state),
    LAST_NAME.getValue(component.state),
    component.props.wlf_id,
    EMAIL.getValue(component.state),
    account_number,
    delivery_type,
    {
      envelope_id: ENVELOPE_ID.getValue(component.state),
    })
    .then(result => {
      if (!result.success) {
        component.setState({
          new_user_error: result.message,
          creating_user: false,
        })
      } else {
        component.setState({
          creating_user: false,
          new_user_error: "",
          show_new_user_dialog: false,
          show_new_user_account_dialog: false,
        });
        component.doLoadProxyOnboarding();
      }
    })
}

const NewUserDialog = props => {

  const component = props.component;
  const header = (
    <div align={"center"}>
      <span>Create New User</span>
    </div>
  );

  const on_cancel = () => {
    component.setState({
      show_new_user_dialog: false,
      show_new_user_account_dialog: false,
      highlight_rects: [],
      new_user_error: "",
      creating_user: false,
    })
  }

  const { FIRST_NAME, LAST_NAME, EMAIL, ENVELOPE_ID, ELECTRONIC_SIGNING_TYPE } = props.prms;

  const button_list = [
    { id: "cancel", label: "Cancel", cb: on_cancel },
    { id: "create",
      label: (
        <TextLoading
          label={"Create"}
          loading={component.state.creating_user}/>),
      cb: on_create(component, props.prms) },
  ];
  const on_highlight_click = () => {
    component.setState({ highlight_rects: [] });
  }

  const has_error = component.state.new_user_error !== "";
  const error_style = {
    color: "red",
    fontSize: "1.5rem",
  }
  const error_container_style = {
    paddingTop: "1rem",
    visibility: has_error ? "visible" : "hidden",
  }
  const error = has_error ? component.state.new_user_error : " ";

  return (
    <Modal2
      header={header}
      buttonList={button_list}
      show={true}>
      <div ref={component.new_user_dialog_ref} style={{position: "relative"}}>
        <HighlightRects
          rects={component.state.highlight_rects}
          container_ref={component.new_user_dialog_ref}
          onClick={on_highlight_click}/>
        { render_pair(component, "First Name", FIRST_NAME) }
        { render_pair(component, "Last Name", LAST_NAME) }
        { render_pair(component, "Email", EMAIL) }
        { render_pair(component, "Signing Type", ELECTRONIC_SIGNING_TYPE) }
        { render_pair(component, "Envelope ID", ENVELOPE_ID)}
        { render_pair(component, "Account Number", ACCOUNT_NUMBER)}
        <div align={"center"} style={error_container_style}>
          <span style={error_style}>{error}</span>
        </div>
      </div>
    </Modal2>
  );
}

export { NewUserDialog, render_pair };
